export default __webpack_public_path__ + "static/flag-us-e6ce92edb46a3dbb1faf8a898c3f49f4.svg";